export default __webpack_public_path__ + "static/map-international-20f8336b78f797984862699d7f931f82.svg";